<template>
  <a @click.prevent="scrollTo('#steps')"
     class="block w-full max-w-xs py-4 mx-auto my-8 text-xl text-center text-white uppercase transition-all rounded-full cursor-pointer md:max-w-3xl font-ww-medium bg-lifeboost-red px-9">

    {{props.buttonText}}

  </a>
</template>

<script setup>

const props = defineProps({
  buttonText: {
    type: String,
    default: 'Shop Lifeboost'
  },
})

defineBuilderComponent({
    friendlyName: "ButtonHealthyCoffee22",
    canHaveChildren: true,
    inputs: [
        {
            name: "buttonText",
            type: "text",
            defaultValue: "Shop Lifeboost"
        }
    ]
});
</script>